import CheckIcon from "@mui/icons-material/Check";
import { Avatar, Badge, Divider, Stack, Tooltip } from "@mui/material";
import { Author } from "../../../manifest/models/author.models";
import { getUsernameFor } from "../../../utils/username";
import "./online-users.component.css";

export interface OnlineUsersProps {
  onlineUsers: Author[];
}

export function OnlineUserIcon(props: { user: Author }) {
  const user = props.user;
  const username = getUsernameFor(user);
  return (
    <Tooltip title={`${username} -- Online Now`} placement="top" arrow>
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        badgeContent={
          <CheckIcon
            sx={{
              fontSize: 14,
              color: "white",
              bgcolor: "#00e676",
              borderRadius: "50%",
              border: "2px solid",
              borderColor: "background.paper",
              width: 20,
              height: 20,
            }}
          />
        }
      >
        <Avatar
          alt={username}
          src={`${user.avatar.filename}`}
          sx={{
            border: "4px solid",
            borderColor: "#00e676",
            boxShadow: "0 0 10px rgba(0, 230, 118, 0.6)",
          }}
        />
      </Badge>
    </Tooltip>
  );
}

export function OnlineUsersBar(props: { onlineUsers: Author[] }) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems={"center"}
      className="online-users-bar-container"
      id={`desktop-top-online-users-bar-container`}
    >
      {props.onlineUsers.map((user) => {
        return <OnlineUserIcon user={user} key={user.id} />;
      })}
      <Divider orientation="vertical" variant="middle" flexItem />
    </Stack>
  );
}
